import { render, staticRenderFns } from "./SectionContents.vue?vue&type=template&id=f5a7d484&scoped=true&lang=pug&"
import script from "./SectionContents.vue?vue&type=script&lang=js&"
export * from "./SectionContents.vue?vue&type=script&lang=js&"
import style0 from "./SectionContents.vue?vue&type=style&index=0&id=f5a7d484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a7d484",
  null
  
)

/* custom blocks */
import block0 from "./SectionContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports